import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const FirstName = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('firstname', {
          required: t('mainReporting:form.mandatory'),
          validate: value => value.length < 21 || t('mainReporting:form.firstName.errors.length')
        })}
        label={t('mainReporting:form.firstName.label')}
        placeholder={t('mainReporting:form.firstName.placeholder')}
        allowOnly={/[\p{L} '-]+/gu}
        autocomplete="given-name"
      />
      <InputError error={error} />
    </>
  )
}

export default FirstName
